var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGantView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4753 12.0332H23.188H13.8747V10.0982H21.34H25.0727V3.72713H21.3363H13.8747V0.897583H12.9763V3.72713H6.798H0V10.0982H6.798H12.9763V12.0332H6.14533V18.4042H12.9727V21.2338H13.871V18.4042H23.1843H28.4717H33V12.0332H28.4753ZM6.798 9.20001H0.898333V4.62163H6.79433V9.20001H6.798ZM23.188 17.5097H7.04367V12.9314H23.188V17.5097Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantView);
export default __webpack_public_path__ + "static/media/GantView.d3fec2c7917cd7ece098b2a31f0585e2.svg";
export { ForwardRef as ReactComponent };